import styled from "styled-components";

export const ImageContainer = styled.div.attrs({ className: "mx-auto" })`
  width: 75%;
  ${({ theme }) => theme.lg`
      width: 100%;
   `}
`;
